import React from "react";

export const SubscriptionContext = React.createContext();